import { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { Digest } from '../services/Digest'; 
import InputFileHasher from '../components/InputFileHasher';
import InputFileTimeStamp from "../components/InputFileTimeStamp"; 
import { SourceTimeStampValidation } from '../services/SourceTimeStampValidation'; 
import { Link } from 'react-router-dom';

const IndexPage = () => {
    const [validation, setValidation] = useState(undefined);
    const [fileDigests, setFileDigests] = useState([]);
    const [algs, setAlgs] = useState(Digest.defaultAlgs);
    const [sourceValidation, setSourceValidation] = useState(undefined);
    const [hashing, setHashing] = useState(false);

    useEffect(() => {
        if (validation !== undefined) {
            setSourceValidation(new SourceTimeStampValidation(validation, fileDigests));
        }
    }, [fileDigests, validation]);

    const sourceOnHashing = async(file) => {
        setHashing(true);
    }

    const sourceOnHashed = async(file, digests) => {
        setHashing(false);
        setFileDigests(digests);
    }

    const tstOnValidated = async(file, validation) => {
        setValidation(validation);
        setAlgs([validation.tokenInfo.alg]);
    }

    return (
        <>
            <div className="main">
                <div>
                    <form className="file-upload-form">
                        <div className="instrucciones">
                            <strong>Seleccionar archivo TST, TSG o SIG  &nbsp; </strong> para comprobar su validacion.
                            <strong> &nbsp; Espere a que se termine de cargar el archivo </strong>
                        </div>
                        <InputFileHasher algs={algs} onHashing={sourceOnHashing} onHashed={sourceOnHashed}></InputFileHasher>
                        <InputFileTimeStamp onValidated={tstOnValidated} />
                    </form>

                    {sourceValidation ?
                        <div className="centrado">
                            {!hashing ?
                            <button className="validar-boton">
                                <Link to="resumenValidado" state={sourceValidation} className="link">
                                    <span>Validar Documentos</span>
                                </Link>
                            </button>
                                :
                            ''
                            }
                        </div>
                        :
                        ''
                    }

                </div>
            </div>
        </>
    );
}

export default IndexPage;
